var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic_con"},[_c('Frame',{attrs:{"title":"客户评级"}},[_c('template',{slot:"contentSlot"},[_c('div',{staticClass:"con_wrapper"},[_c('a-empty',{attrs:{"description":"未查询到相关数据"}})],1)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }